export const loadGoogleMaps = () => {
    const GMAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!window || !GMAPS_API_KEY) return;

    const src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&callback=initMap`;

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    document.body.appendChild(script);
};
